import { Text, View } from "react-native";
import { useResidentContext } from "../../provider/ResidentProvider";
import { useMemo, useRef } from "react";
import KeyValueList from "ui/organisms/KeyValueList";
import { EditResidentPortfolioModal } from "../modals/EditResidentPortfolioModal";
import { EditButton } from "../../molecules/EditButton";
import ViewDocuments from "app/components/molecules/ViewDocuments";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import ResidentDigitalPortfolioForm from "../../organisms/ResidentDigitalPortfolioForm";

export default function ResidentPortfolioTemplate() {
  const { resident } = useResidentContext();
  const ref =
    useRef<React.ComponentRef<typeof EditResidentPortfolioModal>>(null);

  const startEdit = () => {
    ref.current?.show(resident);
  };

  const portfolioData = useMemo(
    () => [
      {
        label: "Resident Portfolio",
        value: (
          <ViewDocuments
            documents={resident?.portfolio_medias ?? []}
            className="mt-8"
          />
        ),
      },
    ],
    [resident],
  );

  return (
    <View className="resident-container">
      <EditButton
        startEdit={startEdit}
        permission={PermissionsEnums.UPDATE_RESIDENT}
      />
      {resident?.portfolio_medias?.length ? (
        <>
          <KeyValueList items={portfolioData} />
        </>
      ) : (
        <Text className="text-typography-600">
          No resident portfolio listed.
        </Text>
      )}

      <View className="border border-gray-200 w-full my-12" />
      <ResidentDigitalPortfolioForm />

      <EditResidentPortfolioModal ref={ref} />
    </View>
  );
}
